<div [formGroup]="form">
  <div class="section">Zugang</div>
  <div class="grid">
    <div class="md:col-3">
      <label class="label" for="propertyKey">Schlüssel</label>
      <input id="propertyKey" type="text" fullWidth nbInput formControlName="propertyKey">
    </div>

    <div class="md:col-3">
      <label class="label" for="keySafeWithPosition">Schlüsselsafe mit Position</label>
      <input id="keySafeWithPosition" type="text" fullWidth nbInput formControlName="keySafeWithPosition">
    </div>

    <div class="md:col-3">
      <label class="label" for="codes">Codes</label>
      <input id="codes" type="text" fullWidth nbInput formControlName="codes">
    </div>

    <div class="md:col-3">
      <label class="label" for="entryCount">Anzahl Eingänge</label>
      <input id="entryCount" min="0" step="1" type="number" nbInput fullWidth formControlName="entryCount">
    </div>
  </div>
</div>
